export default "__VITE_ASSET__FgAmJxOq__"